import Vue from 'vue'
import Router from 'vue-router'

import { publicRoute, protectedRoute } from './config'

import SessionHelper from '@/helpers/SessionHelper'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)
const routes = publicRoute.concat(protectedRoute)
const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
})
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start()
  const { role } = SessionHelper

  // Si la ruta no existe enviamos al 404 Page
  if (!to.matched.some(record => record)) {
    next({
      path: '/404',
    })
  }

  if (typeof to.redirectedFrom !== 'undefined') {
    if (to.path === '/dashboard' && to.redirectedFrom === '/') {
      if (role === null) {
        location.href = '/home.html'
      }
    }
  }

  // Si la ruta existe y requiere autenticacion, validamos o envimos al login.
  if (to.matched.some(record => typeof record.meta.roles !== 'undefined')) {
    if (role === null) {
      next({
        path: '/auth/login',
      })
    }

    const roles = to.meta.roles
    if (roles.includes(role)) {
      next()
    } else {
      next({
        path: '/auth/login',
      })
    }
  } else {
    next() // si no requiere autenticacion pasamos.
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
